import axios from 'axios';
import { createMonthlyPayDetailsMilkPriceQuery } from './queries';
import moment from 'moment-timezone';

const addMilkPrices = (model, date) =>
    new Promise((resolve, reject) => {
        const query = createMonthlyPayDetailsMilkPriceQuery({ model, date: moment(date).format('YYYY-MM') });
        const request = axios.put(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add milk prices'));
            });
    });

export default addMilkPrices;
